export const PANCHANG_COPY = {
  en: {
    eyebrow: "Aaj Ka Panchang",
    headline: "Today's Panchang",
  },
  hi: {
    eyebrow: "आज का पंचांग",
    headline: "आज का पंचांग",
  },
} as const;

export const PANCHANG_CALCULATION_COPY = {
  en: {
    title: "How is this Panchang calculated?",
    place: "Selected place",
    date: "Calculation date",
    timezone: "Local timezone",
    coordinates: "Calculation coordinates (latitude, longitude)",
    basis:
      "The tithi and nakshatra shown are those at local sunrise on the selected date. They can change during the day; their end times mark the next transition.",
    tithi: "Tithi — the lunar day",
    tithiExplanation:
      "Each 12° interval of the Moon’s angular separation from the Sun is one tithi. A tithi can start or end at any hour; it is not a fixed 24-hour day.",
    nakshatra: "Nakshatra — the Moon’s position",
    nakshatraExplanation:
      "The sidereal zodiac is divided into 27 equal sections. The section containing the Moon at sunrise gives the nakshatra shown here.",
    method: "Calculation method",
    methodExplanation:
      "Sun and Moon positions are calculated with Swiss Ephemeris. Rashi and nakshatra use the sidereal zodiac with Lahiri ayanamsa, the adjustment between tropical and sidereal positions.",
    locationExplanation:
      "Sunrise and sunset depend on your location. Tithi transitions occur at the same instant worldwide, but their local clock times differ. The tithi present at sunrise can therefore differ between places.",
    tradition: "Astronomy and traditional guidance",
    traditionExplanation:
      "Celestial positions and rise/set times come from astronomical calculations. Rahu Kaal and auspicious muhurat labels apply traditional Jyotish rules to those timings; they are not scientific predictions of personal outcomes.",
    limits: "Timing limitations",
    limitsExplanation:
      "If the sunrise or sunset calculation is unavailable, approximate times may be used. This result does not identify whether that fallback was used. A missing Moon time means the time is unavailable, not proof that the Moon does not rise or set that day.",
    reference: "Swiss Ephemeris calculation reference",
  },
  hi: {
    title: "इस पंचांग की गणना कैसे होती है?",
    place: "चुना हुआ स्थान",
    date: "गणना की तारीख",
    timezone: "स्थानीय समय क्षेत्र",
    coordinates: "गणना के निर्देशांक (अक्षांश, देशांतर)",
    basis:
      "यहाँ चुनी हुई तारीख के स्थानीय सूर्योदय पर लागू तिथि और नक्षत्र दिखाए गए हैं। ये दिन में बदल सकते हैं; समाप्ति का समय अगले बदलाव को दर्शाता है।",
    tithi: "तिथि — चंद्र दिवस",
    tithiExplanation:
      "सूर्य से चंद्रमा की कोणीय दूरी के हर 12° का अंतराल एक तिथि है। तिथि किसी भी समय शुरू या समाप्त हो सकती है; इसकी अवधि हमेशा 24 घंटे नहीं होती।",
    nakshatra: "नक्षत्र — चंद्रमा की स्थिति",
    nakshatraExplanation:
      "निरयन राशि चक्र को 27 बराबर भागों में बाँटा जाता है। सूर्योदय पर चंद्रमा जिस भाग में होता है, वही नक्षत्र यहाँ दिखाया जाता है।",
    method: "गणना की विधि",
    methodExplanation:
      "सूर्य और चंद्रमा की स्थिति Swiss Ephemeris से निकाली जाती है। राशि और नक्षत्र के लिए लाहिड़ी अयनांश सहित निरयन राशि चक्र का उपयोग होता है। अयनांश सायन और निरयन स्थितियों के बीच का समायोजन है।",
    locationExplanation:
      "सूर्योदय और सूर्यास्त आपके स्थान पर निर्भर करते हैं। तिथि पूरी दुनिया में एक ही क्षण बदलती है, पर घड़ी का स्थानीय समय अलग होता है। इसलिए सूर्योदय पर लागू तिथि अलग-अलग स्थानों में भिन्न हो सकती है।",
    tradition: "खगोलीय गणना और पारंपरिक मार्गदर्शन",
    traditionExplanation:
      "खगोलीय स्थितियाँ और उदय-अस्त के समय खगोल गणना से आते हैं। राहु काल और शुभ मुहूर्त का निर्धारण इन समयों पर ज्योतिष के पारंपरिक नियम लागू करके होता है; ये व्यक्तिगत परिणामों की वैज्ञानिक भविष्यवाणी नहीं हैं।",
    limits: "समय की सीमाएँ",
    limitsExplanation:
      "सूर्योदय या सूर्यास्त की गणना उपलब्ध न होने पर अनुमानित समय लिया जा सकता है। इस परिणाम में यह नहीं बताया जाता कि अनुमानित समय लिया गया है या नहीं। चंद्रोदय या चंद्रास्त का समय खाली होने का अर्थ है कि समय उपलब्ध नहीं है; इससे यह साबित नहीं होता कि उस दिन चंद्रमा का उदय या अस्त नहीं होता।",
    reference: "Swiss Ephemeris गणना संदर्भ",
  },
} as const;
